import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { from, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { JwtService } from 'src/app/core/services/jwt.service/jwt.service';
import { AuthService } from 'src/app/services/auth.service/auth.service';
import { CacheService } from 'src/app/services/cache.service/cache.service';

@Injectable({
  providedIn: 'root',
})
export class AuthentificationGuard implements CanActivate, CanActivateChild {
  constructor(private authService: AuthService, private router: Router, private jwtService: JwtService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    const token = CacheService.GET_ACCESS_TOKEN();
      
    if (this.jwtService.isTokenExpired(token!)) {
      
      return from(this.authService.refresh()).pipe(
        map((e) => {
          return true;
        }),
        catchError((e) => {
          return of(this.router.createUrlTree(['/auth/login']));
        }),
      );
    }

    return of(true);
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.canActivate(childRoute, state);
  }
}
